export default __webpack_public_path__ + "static/media/Beppe2.c641c861.jpg";